<template>
    <h2 class="mt-5 mb-2 text-lg text-gray-400">KYCs</h2>
    <dl class="grid grid-cols-1 gap-5 sm:grid-cols-3">
        <card :loading="loading">
            <p
                class="mb-2 text-sm font-bold text-gray-400 uppercase dark:text-gray-400"
            >
                Válidos
            </p>
            <p
                class="flex text-2xl font-light text-gray-700 dark:text-gray-200"
            >
                {{ stats.checked }}
            </p>
        </card>
        <card :loading="loading">
            <p
                class="mb-2 text-sm font-bold text-gray-400 uppercase dark:text-gray-400"
            >
                Requeridos
            </p>
            <p
                class="flex text-2xl font-light text-gray-700 dark:text-gray-200"
            >
                {{ stats.required }}
            </p>
        </card>
        <card :loading="loading">
            <p
                class="mb-2 text-sm font-bold text-gray-400 uppercase dark:text-gray-400"
            >
                Inconclusivos
            </p>
            <p
                class="flex text-2xl font-light text-gray-700 dark:text-gray-200"
            >
                {{ stats.inconclusive }}
            </p>
        </card>
    </dl>
    <user-kycs></user-kycs>
</template>

<script>
    import Card from "../../components/layouts/Card.vue";
    import UserKycs from "./UserKycs.vue";
    export default {
        components: {Card, UserKycs},
        data() {
            return {
                loading: false,
                stats: {
                    checked: 0,
                    required: 0,
                    inconclusive: 0
                },
            }
        },

        mounted() {
            this.fetch();
        },

        methods: {
            fetch() {
                this.loading = true;
                axios.get('/api/kyc/stats').then(({data}) => {
                    this.stats.checked = data.total_kyc_checked;
                    this.stats.required = data.total_kyc_required;
                    this.stats.inconclusive = data.total_kyc_inconclusive;
                }).catch(({response}) => {
                }).finally(() => {
                    this.loading = false;
                })
            }
        }
    }
</script>
